<template>
    <div v-if="isDisplayed" class="micro-consulting-filter" data-testid="micro-consulting-filter">
        <VJoyCheckbox :checked="false" data-testid="micro-consulting-filter-checkbox" @update:checked="goToMicroConsultingSearch">
            {{ $t('search.filters.micro-consulting.title') }}
            <p class="micro-consulting-filter__text">{{ $t('search.filters.micro-consulting.subtitle') }}</p>
        </VJoyCheckbox>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {navigateTo, useAuth} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import {buildMicroConsultingSearchUrl} from './microConsultingSearchUrl';
    import {useSearchUrlStore} from '../stores/search-url.store';

    const isMicroConsultingSearchPageEnabled = useFeatureFlag('micro-consulting-search-page');
    const {loggedIn, currentIdentityIsClient} = storeToRefs(useAuth());
    const {searchUrlParams} = storeToRefs(useSearchUrlStore());

    const isDisplayed = computed(() => isMicroConsultingSearchPageEnabled.value && loggedIn.value && currentIdentityIsClient.value);

    async function goToMicroConsultingSearch() {
        await navigateTo(buildMicroConsultingSearchUrl(searchUrlParams.value.query));
    }
</script>

<style scoped lang="scss">
    .micro-consulting-filter__text {
        margin: var(--joy-core-spacing-2) 0 0;
        font-size: var(--joy-font-size-primary-200);
    }
</style>
